

import GlobalSearch from '@/components/probaworkflows_base_components/GlobalSearch/GlobalSearch.vue';
import SystemNotifications from '@/components/probaworkflows_base_components/SystemNotifications/SystemNotifications.vue';
import {
  AIC_ONE_LOGOUT_URL,
  GENERATE_SHARE_LINK,
  GET_SUPPORT_CONTACT_URL,
  GET_USER_PROFILE_DETAILS_URL,
  SEND_SHARE_LINK_EMAIL, // <-- ADDED THIS
  get_headers,
  get_token,
  get_user_role
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import ProfileInfo from '@/views/probaworkflows_base/entity/profile_info/ProfileInfo.vue';

import axios from 'axios';

export default {
  name: 'NavBar',
  mixins: [alert_mixin],
  components: {
    ProfileInfo,
    SystemNotifications,
    GlobalSearch
  },

  data: () => ({
    show_profile_modal: false,
    show_notifications: false,
    unread_notifications_count: 0,
    show_drop_down: false,
    user_role: null,
    show_modal: false,
    contact_email: '',
    contact_phone: '',
    copy_status: {
      email: false,
      phone: false,
      message: ''
    },
    is_sidebar_collapsed: false,
    searchQuery: '',
    show_global_search: false,
    share_link: '',
    share_email: '',
    current_user_name: sessionStorage.getItem('lead_name') || '',
    headers: {},
    token: "",
    project_id: sessionStorage.getItem('project_id'),
    company_name : sessionStorage.getItem('company_name')
  }),

  computed: {
    breadcrumb_root_label() {
      return 'DWYPD';
    },

    breadcrumb_root_path() {
      return '/company_management';
    },

    should_show_user_chip_in_navbar() {
      return this.$route.name === 'view_all_user_forms' || this.$route.path === '/view_all_user_forms';
    },

    should_show_logout_only_actions() {
      return this.$route.path === '/view_all_user_forms'
        || this.$route.name === 'DashboardWithId'
        || this.$route.path === '/manage_entity_type';
    },

    user_initials() {
      const name = this.current_user_name || '';
      return name
        .split(' ')
        .filter(Boolean)
        .map((chunk) => chunk.charAt(0).toUpperCase())
        .slice(0, 2)
        .join('') || 'U';
    },
    isOverviewRoute() {
      return this.$route.name === 'overview';
    },
    isAllAdvertsEntityTypeRoute() {
      return this.$route.path === '/view_entity_type' && this.$route.query?.all_adverts === 'true';
    },
    route_breadcrumb_fallback() {
      return this.$route.meta?.breadcrumb || this.$route.name || 'Dashboard';
    },
    get_current_breadcrumb_value() {
      if (this.isOverviewRoute) return 'Dashboard';
      if (this.isAllAdvertsEntityTypeRoute) return 'Job Adverts';
      return this.route_breadcrumb_fallback;
    },

    current_breadcrumb() {
      return this.formatBreadcrumbLabel(this.get_current_breadcrumb_value());
    },

    is_dwypd_recruitment_domain() {
      return window.location.hostname === 'recruitment.dwypd.gov.localhost';
    },

    navbar_user_label() {
      if (this.is_dwypd_recruitment_domain) {
        return this.user_initials;
      }
      return this.current_user_name || this.userDisplayRole || 'Profile';
    },

    userDisplayRole() {
      if (this.user_role === 'Entity') {
        const leadId = sessionStorage.getItem('lead_id');
        return leadId && leadId !== 'null' ? 'Lead' : 'Founder';
      }
      return this.user_role;
    },

    has_support_email() {
      const email = String(this.contact_email || '').trim();
      return email && email.toLowerCase() !== 'null';
    },

    should_hide_entire_navbar() {
      return [
        '/company_management',
        '/manage_entity_type',
        '/view_entity_type',
        '/form_management',
        '/manage_questions',
        '/create_entity',
        '/configure_template',
        '/manage_assigned_workflows',
        '/upload_template',
        '/view_template',
        '/signing_workflow',
        '/action_management',
      ].includes(this.$route.path);
    },

    should_show_navbar() {
      const allowed_routes = [
        '/configure_company_management',
        '/user_management',
        '/roles_management',
        '/permission_management',
        '/action_management',
        '/assigning_permissions',
        '/creating_a_policy',
        // '/manage_entity_type',
        '/manage_questions',
        '/view_template',
        '/signing_workflow',
        '/form_management',
        '/status_management',
        '/data_points',
        '/manage_risks',
        '/create_enquiry_stages',
        // '/view_entity_type',
        '/create_entity',
        '/configure_template',
        '/manage_assigned_workflows',
        '/upload_template',
        '/risk_questions',
        '/create_enquiry_form',
        '/assign_questions_to_enquiry_form',
        '/services',
        '/package_services',
        '/verification_services_configurations',
        '/company_management'
      ];
      return allowed_routes.includes(this.$route.path);
    },

    showBackToJobs() {
      const allowedRoutes = [
        'entity_application_overview',
        'entity_onboarding_forms'
      ];

      return allowedRoutes.includes(this.$route.name);
    }
  },

  methods: {
    formatBreadcrumbLabel(breadcrumb) {
      return String(breadcrumb).replace(/_/g, ' ');
    },
    async fetch_support_contact() {
      const response = await axios.get(GET_SUPPORT_CONTACT_URL);
      const data = response?.data?.data || {};
      this.contact_email = data.contact_email || '';
      this.contact_phone = data.contact_phone || '';
    },

    async sync_current_user_name() {
      const cached_name =
        sessionStorage.getItem('lead_name')
        || sessionStorage.getItem('full_name')
        || localStorage.getItem('lead_name')
        || '';

      if (cached_name) {
        this.current_user_name = cached_name;
        return;
      }

      if (!get_token()) {
        this.current_user_name = '';
        return;
      }

      try {
        if (!this.headers || !Object.keys(this.headers).length) {
          this.headers = get_headers();
        }

        const response = await axios.get(GET_USER_PROFILE_DETAILS_URL, { headers: this.headers });
        const user_data = response?.data?.data || {};
        const first_name = String(user_data.first_name || '').trim();
        const last_name = String(user_data.last_name || '').trim();
        const full_name = String(user_data.full_name || `${first_name} ${last_name}`.trim()).trim();

        this.current_user_name = full_name;

        if (full_name) {
          sessionStorage.setItem('lead_name', full_name);
        }
      } catch (_error) {
        this.current_user_name = '';
      }
    },

        go_to_login() {
          sessionStorage.setItem('auth_redirect_reason', 'navbar_login');
          this.$router.push('/login');
        },
    go_to_register() {
      this.$router.push('/registration');
    },

    handle_search_input() {
      this.show_global_search = this.searchQuery.length > 0;
      this.$refs.global_search?.handle_search(this.searchQuery);
    },

    toggle_notifications() {
      this.show_notifications = !this.show_notifications;
      if (this.show_notifications) {
        this.$refs.system_notifications?.get_unread_notifications();
      }
    },

    update_unread_count(count) {
      this.unread_notifications_count = count;
    },

    go_back() {
      if (this.get_back_route) {
        this.$router.push(this.get_back_route.path);
      }
    },

    toggle_drop_down() {
      this.show_drop_down = !this.show_drop_down;
    },

    go_to_home() {
      this.$router.push('/company_management');
    },

    go_to_jobs(){
      console.log(this.user_role);
      this.$router.push('/view_all_user_forms');
    },

    update_profile() {
      this.show_profile_modal = true;
    },

    close_drop_down() {
      this.show_drop_down = false;
    },

    open_modal() {
      this.show_modal = true;
    },

    close_modal() {
      this.show_modal = false;
    },

    async copy_contact(type) {
      const values = {
        email: this.contact_email,
        phone: this.contact_phone
      };
      const value = Reflect.get(values, type);
      if (!value) {
        return;
      }

      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
        } else {
          this.fallback_copy_text(value);
        }

        const allowed_types = ['email', 'phone'];

        if (allowed_types.includes(type)) {
          Reflect.set(this.copy_status, type, true);

          const message_map = {
            email: 'Email copied!',
            phone: 'Phone number copied!',
          };

        Reflect.set(this.copy_status, 'message', Reflect.get(message_map, type));

          if (this.copy_timeout_id) {
          clearTimeout(this.copy_timeout_id);
        }

        this.copy_timeout_id = setTimeout(() => {
          Reflect.set(this.copy_status, type, false);
          Reflect.set(this.copy_status, 'message', '');
        }, 2000);
        }
      } catch (_error) {
        this.copy_status.message = 'Unable to copy. Please copy manually.';
        setTimeout(() => {
          this.copy_status.message = '';
        }, 1800);
      }
    },

    fallback_copy_text(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const copied = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (!copied) {
        throw new Error('Fallback copy failed');
      }
    },

    handle_click_outside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.close_drop_down();
      }
    },

    logout() {
      const is_aic_one_login = sessionStorage.getItem('is_aic_one_login') === "True";

      if (is_aic_one_login) {
        axios.post(AIC_ONE_LOGOUT_URL, {}, { headers: this.headers })
          .then(response => {
            localStorage.clear();
            sessionStorage.clear();
            window.location = response.data.redirect_url;
          })
          .catch(error => {
            console.warn("error: ", error);
          });

      } else {
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push('/');
      }
    },

    // ---------------------------------------------------------
    // GENERATE SHARE LINK
    // ---------------------------------------------------------
    async generate_share_link() {
      const data = { project_id: this.project_id };

      await axios.post(GENERATE_SHARE_LINK, data, {
        headers: this.headers,
      })
      .then(response => {
        const response_data = response.data;

        if (response_data.status === 'success') {
          this.share_link = response_data.data.share_link;
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        }
      });
    },

    copy_link() {
      if (!this.share_link) {
        return;
      }

      navigator.clipboard.writeText(this.share_link)
        .then(() => {
          this.show_success('Link copied to clipboard!');
        })
        .catch(() => {
          this.show_error('Could not copy link.');
        });
    },

    // ---------------------------------------------------------
    // NEW: SEND SHARE LINK VIA EMAIL
    // * Uses same pattern as GENERATE_SHARE_LINK *
    // ---------------------------------------------------------
    async share_via_email() {
      if (!this.share_email) {
        this.show_error("Please enter an email address.");
        return;
      }

      if (!this.share_link) {
        this.show_error("Please generate the link first.");
        return;
      }

      const data = {
        email: this.share_email,
        share_link: this.share_link,
      };

      await axios.post(SEND_SHARE_LINK_EMAIL, data, { headers: this.headers })
      .then(response => {
        if (response.data.status === "success") {
          this.show_success("Email sent successfully!");
          this.share_email = "";
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        } else {
          this.show_error("Failed to send email.");
        }
      });
    },
  },

  async created() {
    this.user_role = await get_user_role();
    await this.sync_current_user_name();

    if (this.$refs.system_notifications) {
      this.$refs.system_notifications.get_unread_notifications();
    }
  },

  mounted() {
    this.headers = get_headers();
    this.token = get_token();
    document.addEventListener("click", this.handle_click_outside);
    this.fetch_support_contact();
    this.sync_current_user_name();

    this.$nextTick(() => {
      if (this.$refs.system_notifications) {
        this.$refs.system_notifications.get_unread_notifications();
      }
    });
  },

  watch: {
    '$route.fullPath'() {
      this.sync_current_user_name();
    },
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handle_click_outside);
  },
};
